import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { bankIDTranslations } from "@krea/shared/features/bankID";

const resources = {
  en: {
    [bankIDTranslations.namespace]: bankIDTranslations.en,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    supportedLngs: ["en"],
    ns: [bankIDTranslations.namespace],
    defaultNS: bankIDTranslations.namespace,
    fallbackNS: bankIDTranslations.namespace,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false, // Set to false to avoid suspense issues
    },
  });

// biome-ignore lint/style/noDefaultExport: i18next must be exported as default
export default i18n;
